import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { CondicionPagoSelect } from 'sharedComponents/select'

const CondicionesDePagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='C. DE PAGO' htmlFor='select-condicionDePago' md={2} />
      <Col md={10}>
        <Field name='_idCondicionDePago'>
          {({ field }) => (
            <CondicionPagoSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-condicionDePago'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionesDePagoFormGroup)
